import axios, { pluckData } from 'src/utilities/http-client'
import { AccreditationKey } from 'src/v3/content-pipeline/accreditation-health.slice'

export type FloridaApplicationDelivery = {
  method: 'selfPacedOnline' | 'live'
  capceCEType: 'F3' | 'F5'
  label: string
}

export type FloridaApplicationContactHours = {
  declaredCEHours: number
  minutes: number
  creditedContactHours: number
  meetsMinimumLength: boolean
}

export type FloridaApplicationObjective = { sequence: number; text: string }
export type FloridaApplicationReference = { sequence: number; text: string }

export type FloridaApplicationInstructor = {
  id: string
  name: string
  credentials?: string
}

export type FloridaApplicationOutlineRow = {
  sequence: number
  kind: string
  title?: string
  durationMinutes?: number
  startTime?: string
  endTime?: string
  timeZone?: string
}

export type FloridaApplicationAssessment = {
  quizID: string
  passingScore: number
  displayedQuestions: number
  totalQuestions: number
  randomizeQuestions: boolean
}

export type FloridaApplicationCAPCE = {
  courseCode?: string
  topicArea?: string
  classType?: string
  applicationDate?: string
  submissionDate?: string
  allClearDate?: string
  goLiveDate?: string
  expirationDate?: string
}

export type FloridaApplicationAccreditationRow = {
  slot: AccreditationKey
  body: string
  courseNumber?: string
  topicArea?: string
  expirationDate?: string
}

export type FloridaApplicationMissingRequirement =
  | 'description'
  | 'objectives'
  | 'instructors'
  | 'instructorCredentials'
  | 'references'
  | 'outline'
  | 'teachingStrategies'
  | 'assessment'
  | 'capceApproval'
  | 'contactHourMinimum'

export type FloridaApplicationPacket = {
  generatedAt: string
  kind: 'course' | 'event'
  offeringID: string
  provider: string
  title: string
  displayTitle: string
  category?: string
  delivery: FloridaApplicationDelivery
  contactHours: FloridaApplicationContactHours
  description?: string
  practiceGap?: string
  practiceGapEvidence?: string
  learnerEngagement?: string
  learningOutcomes?: string
  objectives: FloridaApplicationObjective[]
  instructors: FloridaApplicationInstructor[]
  references: FloridaApplicationReference[]
  outline: FloridaApplicationOutlineRow[]
  assessment?: FloridaApplicationAssessment
  capce?: FloridaApplicationCAPCE
  accreditations: FloridaApplicationAccreditationRow[]
  targetAudience: string[]
  educationalNeeds: string[]
  missingRequirements: FloridaApplicationMissingRequirement[]
}

export let fetchCourseFloridaApplication = (courseID: string) =>
  axios
    .get<FloridaApplicationPacket>(
      `/api/content-pipeline/accreditation-course/${courseID}/application/florida`,
    )
    .then(pluckData)

export let fetchEventFloridaApplication = (eventID: string) =>
  axios
    .get<FloridaApplicationPacket>(
      `/api/content-pipeline/accreditation-event/${eventID}/application/florida`,
    )
    .then(pluckData)
